"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Divider = function Divider(_ref) {
  var props = _extends({}, _ref);

  return (0, _jsxRuntime.jsx)(_Divider["default"], _objectSpread({}, props));
};

Divider.propTypes = {
  /**
   * Absolutely position the element.
   */
  absolute: _propTypes.bool,

  /**
   * The component used for the root node. Either a string to use a DOM element or a component.
   */
  component: _propTypes.elementType,

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: _propTypes.bool,

  /**
   * The divider orientation.
   */
  orientation: (0, _propTypes.oneOf)(['horizontal', 'vertical']),

  /**
   * The variant to use.
   */
  variant: (0, _propTypes.oneOf)(['fullWidth', 'inset', 'middle'])
};
Divider.defaultProps = {
  absolute: false,
  component: 'hr',
  light: false,
  orientation: 'horizontal',
  variant: 'fullWidth'
};
var _default = Divider;
exports["default"] = _default;